import * as React from "react";
import {Component } from "react";

import "./header.scss";

import {Search} from "../../../core/components/search/search";
import {UiState} from "../../../core/ui-state";
import {SearchConfiguration} from "../../../core/config/search-configuration";

import SVG from "react-inlinesvg";
import kantonsLogo from "../../../assets/images/kt_logo_default_inverted.svg";
import {AppState} from "../app-mobx";
import {MapState} from "../../../core/map-state";
import {MapViewerConfiguration} from "../../../config/map-viewer-configuration";
import {observer} from "mobx-react";
import {AppConfiguration} from "../../../core/config/app-configuration";


export interface HeaderProps {
    view: __esri.MapView | __esri.SceneView | undefined;
    appStore: AppState;
    uiStore: UiState;
    mapStore: MapState;
    appConfig: AppConfiguration;
    capabilities: string[];
    searchConfig?: SearchConfiguration;  // widgetsSearch is also the type for configuration object
    mapViewerConfig: MapViewerConfiguration;
}

@observer
export class Header extends Component<HeaderProps, any> {

    constructor(props: HeaderProps) {
        super(props);
        this.state = {
            search: null
        };
    }
    toggleSidebarVisible(): void {
        const {sidebarVisible} = this.props.uiStore;
        this.props.uiStore.setSidebarVisible(!sidebarVisible);
    }
    render(): React.ReactElement | null {
        const {topic, tracker} = this.props.appStore;
        const mode = this.props.appConfig.mode;
        if (!topic) {
            return null;
        }
        return(
            <header className={"header"}>
                <a href={this.props.appConfig.basename} className="header-logo">
                    <SVG src={kantonsLogo} width={248} height={74}/>
                </a>
                {(mode !== "production" && typeof this.props.mapViewerConfig.htmlContent.betaInfo === "string")? (
                    <div className="geo-test-banner">
                        <div>
                            <p dangerouslySetInnerHTML={
                                {__html: this.props.mapViewerConfig.htmlContent.betaInfo}}/>
                        </div>
                    </div>) : ""}
                <button className="no-focusborder menu-btn-1 offside-button header__mobilenavigation-button"
                    type="button" onClick={() => this.toggleSidebarVisible()}>
                    <span className="header__mobilenavigation-button-text">Navigation</span>
                </button>

                <a href={this.props.appConfig.basename} id="ctl02_lnkTag" className="header__label">
                    <span id="ctl02_htmlSpanHeaderTitle" className="header__label-name"><br/>Auftragsverwaltung</span>
                </a>
                {this.props.capabilities.map((cap) => {
                    if (cap === "search" && this.props.searchConfig) {
                        return (<div id="search" key={"head" + cap} className="layout__search-bar-wrapper">
                            <div className="header__search-bar">
                                <Search
                                    key={cap}
                                    mapStore={this.props.mapStore}
                                    uiStore={this.props.uiStore}
                                    config={this.props.searchConfig}
                                    tracker={tracker}
                                />
                                <button type="button" className="run-search no-focusborder header__search-submit">Suchen
                                </button>
                            </div>
                        </div>
                        );
                    }})}
            </header>
        );
    }
}
